import React from "react";
import { Link } from "react-router-dom";
import "../Assets/css/influencer.css";
import insta from "../Assets/Img/instagram.png";
import youtube from "../Assets/Img/youtube.png";
import facebook from "../Assets/Img/facebook.png";
import LinkedIn from "../Assets/Img/LinkedIn.png";
import call from "../Assets/Img/influ-call.png";
import mail from "../Assets/Img/Influ-mail.png";
import hrline from "../Assets/Img/influ-hr.png";

import { FaEdit } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

export default function InfluencerProfile() {
  return (
    <div className="container py-4" style={{ minHeight: "100vh" }}>
      <div className="mx-auto col-lg-6">
        {/* Social Links & Profile */}
        <div className="card p-3 shadow mt-3">
          <div className="d-flex justify-content-between align-items-center">
            {/* Left: Social Links (Instagram, YouTube) */}
            <div className="d-flex flex-column">
              <Link
                to="#"
                className="d-flex align-items-center text-muted text-decoration-none"
              >
                <img src={insta} alt="Instagram" width={20} className="me-2" />
                <span>john_morgan</span>
              </Link>
              <Link
                to="#"
                className="d-flex align-items-center text-muted text-decoration-none"
              >
                <img
                  src={youtube}
                  alt="Instagram"
                  width={20}
                  className="me-2"
                />
                <span>www.youtube.com/...</span>
              </Link>
            </div>

            {/* Center: Profile Image & Info */}
            <div className="text-center">
              <div className="influ-profile-name">Cardi B</div>

              <div className="mb-2 position-relative">
                <img
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-IxekalnGPASwAXsaURr5C16wWeD0h6.png"
                  alt="Profile"
                  width={80}
                  height={80}
                  className="rounded-circle mx-auto"
                />
              </div>
              <p className="influ-profile-passion">Fashion</p>
            </div>

            {/* Right: Social Links (Facebook, LinkedIn) */}
            <div className="d-flex flex-column text-end">
              <Link
                to="#"
                className="d-flex align-items-center text-muted text-decoration-none"
              >
                <img
                  src={facebook}
                  alt="Instagram"
                  width={20}
                  className="me-2"
                />
                <span>john_morgan</span>
              </Link>
              <Link
                to="#"
                className="d-flex align-items-center text-muted text-decoration-none"
              >
                <img
                  src={LinkedIn}
                  alt="Instagram"
                  width={20}
                  className="me-2"
                />
                <span>www.youtube.com/...</span>
              </Link>
            </div>
          </div>
        </div>

        {/* About Section */}
        <div className="card p-3 shadow mt-3">
          {/* About Section */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="title-influ-profile">About Cardi B</h2>
            <button className="btn btn-light btn-sm">
              <FaEdit />
            </button>
          </div>
          <p className="influ-profile-detail">
            I am a dynamic content creator who inspires and engages audiences
            with authentic storytelling and impactful content. With a perfect
            blend of creativity and influence, connects brands with their ideal
            audience, driving trends and engagement.
          </p>

          {/* Contact Section */}
          <div className="mt-3">
            <h2 className="title-influ-profile">Contact</h2>
            <div className="d-flex flex-row">
              <p className="text-muted m-0">
                <img src={mail} alt="Email" width={20} className="" />
                <Link
                  to="mailto:tonystark@gmail.com"
                  className="ms-2 text-primary text-decoration-none"
                >
                  tonystark@gmail.com
                </Link>
              </p>
              <p className="text-muted m-0 ms-2">
                <img src={call} alt="Email" width={20} className="" />
                <Link
                  to="tel:+917893256664"
                  className="ms-2 text-decoration-none"
                >
                  +91 78932 56664
                </Link>
              </p>
            </div>
          </div>

          {/* Location Section */}
          <div className="mt-3">
            <h2 className="title-influ-profile">Location</h2>
            <p className="influ-profile-location">
              19, Nas Villas, Bandra East, Mumbai, 560098
            </p>
          </div>
        </div>

        {/* Bank Details Section */}
        <div className="card mt-3 p-3 shadow">
          {/* Card Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="title-influ-profile">Bank Details</h2>
            <button className="btn btn-light btn-sm">
              <FaEdit />
            </button>
          </div>

          {/* Bank Details Content */}
          <div className="row">
            <div className="col-md-6">
              <p className="influ-profile bank-detail">Account Holder Name</p>
              <p className="user-bank-detail">Nikhil K</p>
            </div>
            <div className="col-md-6">
              <p className="influ-profile bank-detail">Bank Name</p>
              <p className="user-bank-detail">Kotak Mahindra</p>
            </div>
            <div className="col-md-6">
              <p className="influ-profile bank-detail">Account Number</p>
              <p className="user-bank-detail">88226 565565 484</p>
            </div>
            <div className="col-md-6">
              <p className="influ-profile bank-detail">IFSC Code (India)</p>
              <p className="user-bank-detail">KM02694</p>
            </div>
          </div>
          {/* Image Section (Added after bank details) */}
          <div className="mt-3 text-center">
            <img
              src={hrline}
              alt="Bank Illustration"
              style={{ width: "100%", height: "15px", objectFit: "cover" }}
              className="img-fluid"
            />
          </div>

          {/* UPI Payment Section */}
          <div className="mt-3 p-2   d-flex  align-items-center">
            <p className="upi-influ-profile me-3">nikhil556798@paytm.com</p>
            <span className="upi-influ-profile verify">Verified ✅</span>
          </div>
        </div>
      </div>
    </div>
  );
}
